/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CreativesDataService from '../../services/creatives.service';
import { CreativesListStab } from '../../components/common/alias/CreativeItemModel';
import { MODELSTATES } from 'constants';
import { NEW_CAMP_STAB_DEFAULT_CREATIVE } from '../../components/campaign/creativesSection/utils/CONSTANTS';
import { checkCreativesSection } from 'utils';
import { cloneDeep } from 'lodash-es';

const labels = {
  default: 'Use this Creative',
  cropped: 'Use Cropped',
};
const selectedCreative = {};
const selectedDisabledCreative = {};
//let newCampaignCreativeAndTrackingData = {};
let creativeAndTrackingData = {};

let defaultEntryId = '';

const getDefaultState = () => {
  return {
    uploadingIcon: false,
    uploadingImage: false,
    selectedIcon: {},
    selectedImage: {},
    selectedVideo: {},
    videoType: 0,
    modelState: '',
    uploadImageLastResponse: {},
    uploadedVideoResponse: {},
    creativeModalType: '',
    currentTab: defaultEntryId,
    status: 'active',
    creativesList: [],
    unsavedData: false,
    selectedCreative: selectedCreative,
    selectedDisabledCreative: selectedDisabledCreative,
    creativeImages: [],
    actionLabel: labels.default,
    promptStatePosition: MODELSTATES.EMPTY,
    newImageUrl: '',
    newLandscapeImageUrl: '',
    newVideoUrl: '',
    newLandscapeVideoUrl: '',
    lastUploadedImageName: 'nothing here',
    filterOnMedia: '',
    //newCampaignCreativeAndTrackingData,
    creativeAndTrackingData,
    selectedOnBoardIcon: null,
    selectedOnBoardApk: null,
    uploadedIcon: null,
    uploadedImage: null,
    uploadedVideoLandscape: null,
    uploadedVideoPortrait: null,
    uploading: false,
    resetTrackingAndCreativeFlag: false,
  };
};

export const getCreativesDetails = createAsyncThunk(
  'creatives/getCreativesDetails',
  async (camp_id) => {
    const res = await CreativesDataService.getCreativesDetails(camp_id);
    defaultEntryId = res.data[0].bn_bannerid;
    return [...res.data];
  },
);
export const loadCreativeAndTrackingData = createAsyncThunk(
  'creatives/loadCreativeAndTrackingData',
  async (reqDataObj) => {
    const res = await CreativesDataService.loadCreativeAndTrackingData(reqDataObj);
    creativeAndTrackingData = res.data;
    return res.data;
  },
);
export const addNewCreatives = createAsyncThunk('creatives/addNewCreatives', async () => {
  //console.log('addNewCreatives add new creative');
  const res = CreativesDataService.addNewCreatives();
  return res.data;
});
export const uploadImage = createAsyncThunk('Creative/UploadImage', async (file) => {
  //console.log('UPLOAD  new IMAGE', file);
  const res = await CreativesDataService.uploadMedia(file);
  // defaultEntryId = res.data[0].bn_bannerid;
  //console.log('upload response', res.data);
  return [...res.data];
});
export const uploadVideo = createAsyncThunk('Creative/UploadVideo', async (file) => {
  //console.log('UPLOAD  new VIDEO', file);
  const res = await CreativesDataService.uploadVideo(file);
  // defaultEntryId = res.data[0].bn_bannerid;
  //console.log('upload response', res.data);

  return [...res.data];
});
export const getCreativeIcons = createAsyncThunk('Creative/GetCreativeIcons', async () => {
  const res = await CreativesDataService.getCreativeIcons();
  console.log('getCreativeIcons:', res);

  return [...res.data];
});
export const getCreativeImages = createAsyncThunk('Creative/GetCreativeImages', async () => {
  const res = await CreativesDataService.getCreativeImages();
  //console.log('getCreativeImages:', res);

  return [...res.data];
});
export const deleteCreativeMedia = createAsyncThunk('Creative/deleteCreativeMedia', async () => {
  const res = await CreativesDataService.deleteCreativeMedia({
    mediaName: 'icon',
    mediaType: 'video',
  });
  //console.log('deleteCreativeMedia:', res);

  return [...res.data];
});

const creativesSlice = createSlice({
  name: 'creatives',
  initialState: getDefaultState(),
  reducers: {
    setDefaultState: (state) => {
      return getDefaultState();
    },
    selectTab: (state, action) => {
      state.currentTab = action.payload;
    },
    resetTrackingAndCreative: (state) => {
      state.creativeAndTrackingData = {};
      state.selectedCreative = {};
      state.creativesList = [];
      state.resetTrackingAndCreativeFlag = true;
    },
    resetTrackingAndCreativeFlag: (state) => {
      state.resetTrackingAndCreativeFlag = false;
    },
    setIsUploading: (state, action) => {
      state.uploading = action.payload;
    },
    setUploadedIcon: (state, action) => {
      state.uploadedIcon = action.payload;
    },
    setUploadingIcon: (state, action) => {
      state.uploadingIcon = action.payload;
    },

    setUploadedImage: (state, action) => {
      state.uploadedImage = action.payload;
    },
    setUploadingImage: (state, action) => {
      state.uploadingImage = action.payload;
    },
    setUploadedVideoLandscape: (state, action) => {
      state.uploadedVideoLandscape = action.payload;
    },
    setUploadedVideoPortrait: (state, action) => {
      state.uploadedVideoPortrait = action.payload;
    },
    setSelectedIcon: (state, action) => {
      //console.log('setSelectedIcon', action.payload);
      state.selectedIcon = action.payload;
    },
    setSelectedImage: (state, action) => {
      //console.log('setSelectedImage', action.payload);
      state.selectedImage = action.payload;
    },
    setSelectedVideo: (state, action) => {
      console.log('setSelectedVideo', action.payload);
      state.selectedVideo = action.payload;
    },
    changePromptLabel: (state, action) => {
      state.actionLabel = action.payload;
    },
    changeModelState: (state, action) => {
      //console.log('changeModelState!!!', action.payload);
      state.creativeModalType = action.payload.creativeModalType;
      state.modelState = action.payload.modelState;
    },
    deleteCreativeMedia: (state, action) => {
      //console.log('deleteCreativeMedia!!!', action.payload);
      state.creativeImages = [...state.creativeImages];
    },
    changePromptState: (state, action) => {
      state.promptStatePosition = action.payload;
    },
    changeIconImage: (state, action) => {
      state.selectedCreative.bn_id = action.payload;
    },
    useCropped: (state) => {
      state.actionLabel = labels.default;
    },
    changeCreative: (state, action) => {
      //console.log(JSON.parse(JSON.stringify(action.payload)));
      state.selectedCreative = action.payload;
    },
    updateCurrentCreativeImageReplacement: (state, action) => {
      //console.log('updateCurrentCreativeImageReplacement', action.payload.file_name);
      state.newImageUrl = action.payload;
    },
    updateCurrentCreativeLandscapeReplacement: (state, action) => {
      //console.log('updateCurrentCreativeLandscapeReplacement', action.payload.file_name);
      state.newLandscapeImageUrl = action.payload;
    },
    updateCurrentCreativeVideoReplacement: (state, action) => {
      //console.log('updateCurrentCreativeVideoReplacement', action.payload.file_name);
      state.newVideoUrl = action.payload;
      state.selectedImage = action.payload;
      state.uploadedVideoResponse = null;
    },
    addNewCreative: (state, action) => {
      //console.log('add new creative', action);
      const { newItem, position } = action.payload;
      state.unsavedData = true;
      let creativesListCopy = cloneDeep(state.creativesList);
      creativesListCopy.splice(position, 0, newItem);
      state.creativesList = creativesListCopy;
    },
    updateCreativeListAfterSave: (state, action) => {
      console.log('updateCreativeListAfterSAve', action);
      state.unsavedData = false;
      state.creativesList = action.payload; // Using spread operator
    },
    changesMade: (state) => {
      state.unsavedData = true;
    },
    changeFilter: (state, action) => {
      //console.log('changeFilter', action);
      state.filterOnMedia = action.payload;
    },
    deleteOnBoardingAppIcon: (state) => {
      console.log('deleteOnBoardingAppIcon');
      state.creativeAndTrackingData.app_icon = null;
      state.selectedCreative.icon = null;
    },
    createDefaultNewCampCreative: (state, action) => {
      console.log('createDefaultNewCampCreative');
      state.selectedCreative = action.payload;
    },
    changeOrderNextThreeCreative: (state, action) => {
      const { creativesList } = state;
      const firstThreeItems = creativesList.slice(0, 3);
      state.creativesList = [...firstThreeItems, ...action.payload];
    },
    deleteSelectedCreative: (state) => {
      const { creativesList, selectedCreative } = state;
      // console.log(JSON.parse(JSON.stringify(selectedCreative)));
      // console.log(JSON.parse(JSON.stringify(creativesList)));
      if (typeof selectedCreative.bn_bannerid !== 'number') {
        const newCreativeList = creativesList.filter(
          (creative) => creative.bn_bannerid !== selectedCreative.bn_bannerid,
        );
        state.creativesList = newCreativeList;
      } else {
        creativesList?.forEach((item) => {
          if (item?.bn_bannerid === selectedCreative?.bn_bannerid) {
            item.status = 9;
          }
        });
      }

      const newSelectedCreative = creativesList.find(({ status }) => status !== 9);

      state.selectedCreative = newSelectedCreative;
      state.unsavedData = true;
    },
    updateProperty: (state, action) => {
      const { selectedCreative, creativesList } = state;
      // console.log(JSON.parse(JSON.stringify(selectedCreative)));
      // console.log(JSON.parse(JSON.stringify(creativesList)));
      const { propField, newValue } = action.payload;

      selectedCreative[propField] = newValue;
      if (propField === 'icon') {
        selectedCreative.icon_media_id = '';
      } else if (propField === 'image') {
        selectedCreative.image_media_id = '';
      } else if (propField === 'video_landscape') {
        selectedCreative.video_landscape_media_id = '';
      } else if (propField === 'video_portrait') {
        selectedCreative.video_portrait_media_id = '';
      }

      creativesList?.forEach((item) => {
        if (item?.bn_bannerid === selectedCreative?.bn_bannerid) {
          item[propField] = newValue;

          if (propField === 'icon') {
            item.icon_media_id = '';
          } else if (propField === 'image') {
            item.image_media_id = '';
          } else if (propField === 'video_landscape') {
            item.video_landscape_media_id = '';
          } else if (propField === 'video_portrait') {
            item.video_portrait_media_id = '';
          }
        }
      });

      state.unsavedData = true;
    },
    clearCreativeTokenIDs: (state) => {
      const { creativesList } = state;
      state.creativesList =
        creativesList?.map((item) => ({ ...item, creative_id_token: '' })) || [];
      state.selectedCreative = { ...state.selectedCreative, creative_id_token: '' };
    },
    restoreCreativeTokenIDs: (state, action) => {
      const { creativesList, selectedCreative } = state;
      const initialTokens = action.payload;
      const currentToken = initialTokens.find((i) => i.id === selectedCreative.bn_bannerid);
      state.creativesList =
        creativesList?.map((item) => {
          const token = initialTokens.find((i) => i.id === item.bn_bannerid);
          const newToken = token?.creative_id_token || '';
          return { ...item, creative_id_token: newToken };
        }) || [];
      if (currentToken?.creative_id_token)
        state.selectedCreative = {
          ...state.selectedCreative,
          creative_id_token: currentToken.creative_id_token,
        };
    },

    resetLastSelectedNewVideoUrl: (state) => {
      state.newVideoUrl = null;
      state.unsavedData = true;
    },
    updateMediaUploadResponse: (state, action) => {
      state.uploadedVideoResponse = action.payload;
      state.newVideoUrl = null;
      state.unsavedData = true;
    },
    updateMediaProperty: (state, action) => {
      const { selectedCreative, creativesList } = state;
      const { payload } = action;
      const selectedCreativeItem = creativesList?.find(
        (item) => item?.bn_bannerid === selectedCreative?.bn_bannerid,
      );
      console.log('state', JSON.parse(JSON.stringify(state)));
      console.log('selectedCreative', JSON.parse(JSON.stringify(selectedCreative)));
      console.log('creativesList', JSON.parse(JSON.stringify(creativesList)));
      console.log('selectedCreativeItem', JSON.parse(JSON.stringify(selectedCreativeItem)));

      if (payload.newVideoUrl && payload.newVideoUrl.video_type === 1) {
        selectedCreative.video_media_id = payload.newVideoUrl.media_id;
        selectedCreative.bn_video_url = payload.newVideoUrl.file_name;

        selectedCreativeItem.video_media_id = payload.newVideoUrl.media_id;
        selectedCreativeItem.bn_video_url = payload.newVideoUrl.file_name;
      }
      if (payload.portraitVideo) {
        selectedCreative.portrait_video_media_id = payload.portraitVideo.media_id;
        selectedCreative.video_portrait = payload.portraitVideo.file_name;
      }
      if (payload.landscapeVideo) {
        //console.log('updateMediaProperty');
        selectedCreative.video_landscape_media_id = payload.portraitVideo.media_id;
        selectedCreative.video_landscape = payload.portraitVideo.file_name;
      }
      if (payload.file_name) {
        console.log('image_type', payload.image_type);
        if (payload.image_type === 1) {
          selectedCreative.image_media_id = payload.media_id;
          selectedCreative.image = payload.file_name;

          selectedCreativeItem.image_media_id = payload.media_id;
          selectedCreativeItem.image = payload.file_name;
        }

        if (payload.image_type === 0) {
          //console.log(JSON.parse(JSON.stringify(selectedCreative)));
          selectedCreative.icon_media_id = payload.media_id;
          selectedCreative.icon = payload.file_name;

          selectedCreativeItem.icon_media_id = payload.media_id;
          selectedCreativeItem.icon = payload.file_name;
        }
      }

      state.unsavedData = true;
    },
    setSelectedDisabledItem: (state, action) => {
      state.selectedDisabledCreative = action.payload;
    },
    defaultSetOnBoardIcon: (state, action) => {
      state.selectedOnBoardIcon = action.payload;
    },
    setOnBoardIcon: (state, action) => {
      state.selectedOnBoardIcon = action.payload;
      state.unsavedData = true;
    },
    updateTrackingsArrAfterSave: (state, action) => {
      state.creativeAndTrackingData.creativesTracking = action.payload;
    },
    updateAllTrackings: (state, action) => {
      const trackingArr = state?.creativeAndTrackingData?.creativesTracking;
      for (const element of trackingArr) {
        element[action.payload.propField] = action.payload.newValue;
      }
      state.unsavedData = true;
    },
    updateTokensInAllTrackings: (state, action) => {
      const dataArr = action.payload;
      const trackingArr = state?.creativeAndTrackingData?.creativesTracking;
      for (const { field, newValue } of dataArr) {
        for (const element of trackingArr) {
          element[field] = newValue;
        }
      }
      state.unsavedData = true;
    },
    updateTokensInCurrentTracking: (state, action) => {
      const { dataArray, idToUpdate } = action.payload;
      const victim = state.creativeAndTrackingData?.creativesTracking?.find(
        (item) => idToUpdate === item?.bn_bannerid,
      );
      for (const { field, newValue } of dataArray) {
        victim[field] = newValue;
      }
      state.unsavedData = true;
    },
    updateOneFieldCurrentTracking: (state, action) => {
      const { idToUpdate, propField, newValue } = action.payload;
      const victim = state.creativeAndTrackingData?.creativesTracking?.find(
        (item) => idToUpdate === item?.bn_bannerid,
      );

      if (victim) victim[propField] = newValue;
      state.unsavedData = true;
    },
    updateTrackingDataForCreative: (state, action) => {
      state.creativeAndTrackingData?.creativesTracking?.forEach((item) => {
        item[action.payload.propField] = action.payload.newValue;
      });
      state.unsavedData = true;
    },
    addTrackingDataForCreative: (state, action) => {
      //console.log('addTrackingDataForCreative', action.payload);
      state.creativeAndTrackingData?.creativesTracking?.push(action.payload);
      state.unsavedData = true;
    },
    //
    putCreativeAndTrackingDataToStore: (state, action) => {
      state.creativeAndTrackingData = action.payload;
    },
    updateTrackingDataWithNewLinkStateModel: (state, action) => {
      state.creativeAndTrackingData.link_state_model_dic = action.payload;
    },
    add_tmp_id_to_creatives_and_tracking: (state, action) => {
      //console.log('add_tmp_id_to_creatives_and_tracking', action.payload);
      state.creativeAndTrackingData = action.payload.trackingData;
      state.creativesList = action.payload.creativeData;
    },
    //
    putCreativeDetails: (state, action) => {
      //console.log('putCreativeDetails', action.payload);
      state.creativesList = [...action.payload];
    },
    setCreativesList: (state, action) => {
      // console.log('setCreativesList', action.payload);
      state.creativesList = [...action.payload];
    },
  },
  // extraReducers: {
  //   [addNewCreatives.fulfilled]: (state, { payload }) => {
  //     state.creativesList = [...CreativesListStab];
  //   },

  //   [getCreativeImages.fulfilled]: (state, { payload }) => {
  //     //console.log('getCreativeImages fulfilled!!!!!!!!!!!!!!!!:', payload);
  //     state.imageList = [...payload];
  //   },

  //   [uploadImage.fulfilled]: (state, { payload }) => {
  //     //console.log('uploadImage.fulfilled!:', payload, state);
  //     state.lastUploadedImageName = [...payload.file_name];
  //   },
  //   [getCreativesDetails.fulfilled]: (state, { payload }) => {
  //     console.log('getCreativesDetails.fulfilled');
  //     if (payload?.length < 1) {
  //       console.log('no creatives use stab!!');
  //     }
  //     state.creativesList = [...payload];
  //     //return { ...state, creativesList: payload };
  //   },
  //   [getCreativesDetails.rejected]: (state, { payload }) => {
  //     //console.log('Rejected!', payload);
  //     const newDefaultCreative = { ...NEW_CAMP_STAB_DEFAULT_CREATIVE };
  //     newDefaultCreative.title = state.newCampaignCreativeAndTrackingData.title;
  //     newDefaultCreative.name = state.newCampaignCreativeAndTrackingData.title;
  //     console.log('getCreativesDetails', state.newCampaignCreativeAndTrackingData);
  //     state.creativesList = [newDefaultCreative];
  //   },

  //   [loadCreativeAndTrackingData.fulfilled]: (state, { payload }) => {
  //     //console.log('loadCreativeAndTrackingData fulfilled!:', payload);
  //     state.creativeAndTrackingData = payload;
  //   },
  // },
});

export const creativesActions = creativesSlice.actions;
export default creativesSlice.reducer;
